// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ygQs","question":"styles_question__16Equ","description":"styles_description___rLXx"};